import {css, html, LitElement} from 'lit';
import {NAME_LABEL, PROJECTS_LABEL} from './labels';
import {customElement, property} from 'lit/decorators.js';
@customElement('projects-page')
export class ProjectsPageElement extends LitElement {
  @property({type: Boolean, reflect: true})
  hidden = false;

  @property({type: Object})
  projects: {id: string; title: string; content: string}[] = [];

  static get styles() {
    return css`
      :host {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
      }
      .container {
        transition: background 0.3s ease;
        min-height: 100vh;
        overflow: auto;
        background: rgba(255, 255, 255, 0.95);
      }
      .page {
        padding: 5rem 1rem 0;
        max-width: 860px;
        margin: 0 auto;
      }
      ul {
        margin: 1rem 0 2rem;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
        grid-gap: 3rem;
        list-style: none;
        padding: 0;
      }
      li {
        font-size: 1rem;
        line-height: 1.5rem;
        margin: 0 0 1rem 0;
        text-align: center;
      }
      img {
        object-fit: contain;
        height: 250px;
        max-width: 100%;
      }
      .project__heading {
        text-decoration: none;
        font-weight: 700;
      }
    `;
  }

  updated(changedProps: Map<any, any>) {
    if (changedProps.has('hidden') && !this.hidden) {
      document.title = `${PROJECTS_LABEL()} — ${NAME_LABEL()}`;
    }
  }

  render() {
    return html`
      <div class="container">
        <div class="page">
          <ul class="projects">
            ${this.projects.map(project => {
              return html`
                <li class="project">
                  <app-link href="/projects/${project.id}/">
                    <img src="/physics-images/${project.id}.png" alt="" />
                    <div class="project__heading">${project.title}</div>
                  </app-link>
                </li>
              `;
            })}
          </ul>
        </div>
      </div>
      <page-footer></page-footer>
    `;
  }
}
